"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _mobx = require("mobx");

var _ActionStore2 = require("../../../higher-order/ActionStore");

var _includes = _interopRequireDefault(require("lodash/includes"));

var _class, _descriptor;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

var RoleStore = (_class = /*#__PURE__*/function (_ActionStore) {
  _inherits(RoleStore, _ActionStore);

  var _super = _createSuper(RoleStore);

  function RoleStore(props, dispatcher) {
    var _this;

    _classCallCheck(this, RoleStore);

    _this = _super.call(this, dispatcher);

    _initializerDefineProperty(_assertThisInitialized(_this), "roles", _descriptor, _assertThisInitialized(_this));

    if (props.roles) {
      // Format roles to lowercase and replace spaces with dashes
      _this.roles = props.roles.map(function (role) {
        return role.toLowerCase().replace(/\s+/g, '-');
      });
    }

    return _this;
  }

  _createClass(RoleStore, [{
    key: "hasOpsAdminRole",
    get: function get() {
      return (0, _includes.default)(this.roles, "operations-admins");
    }
  }, {
    key: "hasIntranetAdminRole",
    get: function get() {
      return (0, _includes.default)(this.roles, "intranet-admins");
    }
  }, {
    key: "hasMakerCheckerUserRole",
    get: function get() {
      return (0, _includes.default)(this.roles, "makercheckerusers");
    }
  }, {
    key: "hasMakerCheckerAdminRole",
    get: function get() {
      return (0, _includes.default)(this.roles, "makercheckeradmins");
    }
  }]);

  return RoleStore;
}(_ActionStore2.ActionStore), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "roles", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "hasOpsAdminRole", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasOpsAdminRole"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasIntranetAdminRole", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasIntranetAdminRole"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasMakerCheckerUserRole", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasMakerCheckerUserRole"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasMakerCheckerAdminRole", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasMakerCheckerAdminRole"), _class.prototype)), _class);
exports.default = RoleStore;